import PopupComponent, { Header, IPopupProps } from '@components/std-components/Popup'
import React, { FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import TemplateList, { CopyTemplateListProps } from './TemplateList'
import { EnhancedCrossIcon } from '@components/UI-Components/svg'
import { makeStyles } from '@material-ui/core'
import { CentricTypography } from '@core/component/CentricTypography'

export interface TemplateListPopupProps
  extends CopyTemplateListProps,
    Pick<IPopupProps, 'open' | 'onClose'> {}

const useStyles = makeStyles(() => ({
  templateContainer: {
    display: 'flex',
    height: 650,
    flexDirection: 'column',
    width: 595,
    gap: 20
  },
  templateHeader: {
    display: 'flex',
    width: 595,
    padding: '25px  25px 0px  25px',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  templateContenContainer: {
    height: 581,
    maxHeight: 581,
    flexDirection: 'column',
    gap: 20,
    flexShrink: 0
  },
  cancelIcon: {
    height: 24
  },
  templateHeaderTypography: {
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '0.32px'
  }
}))

const TemplateListPopup: FC<TemplateListPopupProps> = ({
  open,
  onClose,
  onCancel,
  ...listProps
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const ref = useRef<any>()
  return (
    <PopupComponent
      ref={ref}
      open={open}
      onClose={onClose}
      contentStyle={{
        width: 597,
        maxWidth: 597,
        height: 650,
        maxHeight: 650,
        padding: '0px 0px'
      }}
      nested
    >
      <div className={classes.templateContainer}>
        <Header>
          <div className={classes.templateHeader}>
            <CentricTypography variant='h4' className={classes.templateHeaderTypography}>
              {t(
                'order.quantitiesAndBook.modal.paste.templateTitle',
                'Select template to paste'
              )}
            </CentricTypography>

            <div onClick={() => ref?.current?.close()} className={classes.cancelIcon}>
              <img
                className='cursor-pointer'
                src={EnhancedCrossIcon}
                alt='Cancel'
                title={t('common.label.cancel', 'Cancel')}
              />
            </div>
          </div>
        </Header>
        <div className={classes.templateContenContainer}>
          <TemplateList
            {...listProps}
            onCancel={() => {
              ref?.current?.close()
              onCancel?.()
            }}
          />
        </div>
      </div>
    </PopupComponent>
  )
}

export default TemplateListPopup
